import React, {Component} from 'react'

import PaperBlock from "../../../ui/PaperBlock"

import Button from '@material-ui/core/Button'

/**
 * onSaveClick
 * onCancelClick
 */

class ActionPanel extends Component {

    render() {
        return <PaperBlock style = {{display: "flex", justifyContent: "right"}}>
            <Button
				onClick = {e => {
					e.stopPropagation()
					if (typeof this.props.onSaveClick === "function") {
						this.props.onSaveClick()
					}
				}}
			>Сохранить</Button>                 
            <Button
				onClick = {e => {
					e.stopPropagation()
					if (typeof this.props.onCancelClick === "function") {
						this.props.onCancelClick()
					}
				}}
			>Отмена</Button>            
        </PaperBlock>
    }

}

export default ActionPanel